import { render } from "./EmployeeTagPanel.vue?vue&type=template&id=6c64ab98&ts=true"
import script from "./EmployeeTagPanel.vue?vue&type=script&lang=ts"
export * from "./EmployeeTagPanel.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../sf-playbook-app/APP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__